import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

//theme color
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { muiThemeColors } from "./common/colorConst";

// MUIテーマにフォントを追加
const theme = createTheme({
  ...muiThemeColors,
  typography: {
    fontFamily:
      "'Noto Sans JP','Lato', 'Open Sans', 'Sawarabi Gothic','Kosugi Maru', 'Nanum Gothic', sans-serif",
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
